import React, { useState, useEffect } from "react";
import AccessPermission from "../pages/AccessPermission";
import Login from "../pages/Login";
import Home from "../pages/Home";
import Modules from "../pages/Modules";
import User from "../pages/User";
import Company from "../pages/Company";
import ModulePermission from "../pages/ModulePermission";
import FileManagement from "../pages/FileManagement";
import Layout from "../containers/Layout";
import {
  verifyPermission,
  isAuthenticated,
  decodeToken,
} from "../services/auth";

import { Switch, Route, RouteProps, Redirect } from "react-router-dom";
import Trainee from "../pages/Trainee";
import Influencer from "../pages/Influencer";
import Twygo from "../pages/Twygo";
import TwygoCourses from "../pages/Twygo/Courses";
import FirstAccessProfile from "../pages/FirstAccessProfile";
import api from "../services/api";
import TemplateTrack from "../pages/TemplateTrack";

interface PrivateRouteProps extends RouteProps {
  component: any;
  roles?: number[];
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const { component: Component, roles, ...rest } = props;
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [isFirstAccess, setIsFirstAccess] = useState(false);

  useEffect(() => {
    const fetchPermissionWithRole = async () => {
      const response = await verifyPermission(roles);
      setAuthenticated(response);

      if (response) {
        checkFirstAccess();
      } else {
        setLoading(false);
      }
    };

    const fetchPermissionWithOutRole = async () => {
      const response = await isAuthenticated();
      setAuthenticated(response);

      if (response) {
        checkFirstAccess();
      } else {
        setLoading(false);
      }
    };

    const checkFirstAccess = async () => {
      try {
        const userInfo = decodeToken();

        if (!userInfo || !userInfo.id) {
          setIsFirstAccess(false);
          setAuthenticated(false);
          setLoading(false);
          return;
        }

        const { data } = await api.get(`/user/${userInfo.id}`);
        const hasFirstAccess = data?.content.first_access === true;

        setIsFirstAccess(hasFirstAccess);
        localStorage.setItem("first_access", String(hasFirstAccess));
        setLoading(false);
      } catch (error) {
        console.error("Erro ao verificar primeiro acesso:", error);

        setIsFirstAccess(false);
        localStorage.setItem("first_access", "false");
        setLoading(false);
      }
    };

    if (roles) {
      fetchPermissionWithRole();
    } else {
      fetchPermissionWithOutRole();
    }
  }, [roles]);

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        loading ? (
          <></>
        ) : authenticated ? (
          isFirstAccess && routeProps.location.pathname !== "/first-access" ? (
            <Redirect
              to={{
                pathname: "/first-access",
                state: { from: routeProps.location },
              }}
            />
          ) : (
            <Layout>
              <Component {...routeProps} />
            </Layout>
          )
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: routeProps.location },
            }}
          />
        )
      }
    />
  );
};

const Routes = () => {
  return (
    <Switch>
      <PrivateRoute
        exact
        path="/access-permission"
        component={AccessPermission}
      />
      <PrivateRoute exact path="/modules" component={Modules} />
      <PrivateRoute exact path="/users" component={User} />
      <PrivateRoute exact path="/companies" component={Company} />
      <PrivateRoute exact path="/twygo-users" component={Twygo} />
      <PrivateRoute exact path="/twygo-courses" component={TwygoCourses} />
      <PrivateRoute
        exact
        path="/template-track-users"
        component={TemplateTrack}
      />

      <PrivateRoute
        exact
        path="/module-permission"
        component={ModulePermission}
      />

      <PrivateRoute exact path="/files-management" component={FileManagement} />
      <PrivateRoute path="/trainee" component={Trainee} />
      <PrivateRoute path="/influencer" component={Influencer} />

      <Route exact path="/login" component={Login} />

      <Route
        exact
        path="/first-access"
        render={(routeProps) => {
          const isAuth = localStorage.getItem("access-token");
          const isFirstAccess = localStorage.getItem("first_access") === "true";

          if (!isAuth) {
            return (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { from: routeProps.location },
                }}
              />
            );
          }

          if (!isFirstAccess) {
            return (
              <Redirect
                to={{
                  pathname: "/",
                  state: { from: routeProps.location },
                }}
              />
            );
          }

          return <FirstAccessProfile {...routeProps} />;
        }}
      />

      <PrivateRoute path="*" component={Home} />
    </Switch>
  );
};

export default Routes;
